class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
      setTimeout(() => {
        removeLoyaltyIfNeeded();
      }, 500);
    });

    async function removeLoyaltyIfNeeded() {
      try {
        const cartResp = await fetch('/cart.js');
        const cartData = await cartResp.json();
        // console.log(cartData);

        const currentLoyalty = cartData?.attributes?._loyalty_redemption_payload;
        if (currentLoyalty && currentLoyalty !== 'e30=') {
          const attributes = {
            _loyalty_redemption_payload: 'e30='
          };
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes })
          });

          const pointTagsContainer = document.getElementById('pointTagsContainer');
          if (pointTagsContainer) {
            pointTagsContainer.innerHTML = '';
          }

          const inputField = document.querySelector('.redeem-point-input');
          const pointSubmit = document.querySelector('.point-submit');
          if (inputField) {
            inputField.disabled = false;
          }
          if (pointSubmit) {
            pointSubmit.disabled = false;
            pointSubmit.classList.remove('disabled');
          }
          renderCartSections();
        }
      } catch (error) {
        console.error('Error checking or updating cart loyalty attribute:', error);
      }
    }

    async function renderCartSections() {
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        const sections = cartItems.getSectionsToRender();    
        const response = await fetch(`${routes.cart_url}?sections=${sections.map(section => section.section).join(',')}`);
        const data = await response.json();
        sections.forEach(section => {
          const elementToReplace = document.querySelector(`#${section.id} ${section.selector}`) || document.getElementById(section.id);
          if (elementToReplace) {
            elementToReplace.innerHTML = cartItems.getSectionInnerHTML(data[section.section], section.selector);
          }
        });
      } else {
        console.error('CartItems element not found');
      }
    }
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      }
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    const name = event.target.getAttribute("name");
    if (name === "variant") {
      this.updateVariant(event);
    }
    if (name !== "updates[]") {
      return;
    }
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name"),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      fetch(`${routes.cart_url}?section_id=cart-drawer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const selectors = ["cart-drawer-items", ".cart-drawer__footer"];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch(`${routes.cart_url}?section_id=main-cart-items`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const sourceQty = html.querySelector("cart-items");
          this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }

    // console.log('Cart updateddddd');

     // Add the checkout-shipping section update logic here
    fetch(`${routes.cart_url}?section_id=main-cart-footer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const targetElement = document.getElementById("freeShipWidget"); // Or the appropriate ID
          if (targetElement) {
            const newShippingSection = html.querySelector("#freeShipWidget"); // Or the appropriate selector
            if (newShippingSection) {
              targetElement.innerHTML = newShippingSection.innerHTML;
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });

        // Add the checkout-shipping section update logic here
    fetch(`${routes.cart_url}?section_id=main-cart-footer`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, "text/html");
          const targetElement = document.querySelector(".points-widget"); // Or the appropriate ID
          if (targetElement) {
            const newPointsSection = html.querySelector(".points-widget"); // Or the appropriate selector
            if (newPointsSection) {
              targetElement.innerHTML = newPointsSection.innerHTML;
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: "#cart-ordersummary",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: "#freeShipWidget",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".points-widget",
      },
    ];
  }

  updateVariant(event) {
    const line = event.target.dataset.index;
    const optionName = event.target.getAttribute("option-name");
    const optionValue = event.target.value;
    const parent = event.target.closest("variant-options-cart");
    const variants = parent.getVariants();
    const selectedOptions = parent.getSelectedOptions();
    const oldValueOfOption = selectedOptions[optionName];
    const oldVariant = parent.getSelectedVariant(variants, selectedOptions);
    const variant = parent.getSelectedVariant(variants, {
      ...selectedOptions,
      [optionName]: optionValue,
    });
    const cartItem = document.getElementById(`CartItem-${line}`);
    const quantityInput = cartItem.querySelector(`#Quantity-${line}`);
    const quantity = quantityInput.value;

    const revertVariant = function () {
       const selectElement = parent.querySelector(`select[option-name="${optionName}"]`);
      if (oldValueOfOption && selectElement) {
        selectElement.value = oldValueOfOption;
      }
    }

    const data = {
      variantId: variant.id,
      line,
      quantity,
      oldVariantId: oldVariant.id,
      revertVariant
    }
    this.addToCartBtn(data);
  }

  addToCartBtn({
      variantId,
      line,
      quantity,
      oldVariantId,
      revertVariant
    }) {
    this.enableLoading(line);
    const cartData = {
      items: [
        {
          id: variantId,
          quantity,
        },
      ],
      sections: this.getSectionsToRender().map((section) => section.section),
      section_url: window.location.pathname,
    };

    const headers = {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
    };
    fetch("/cart/add.js", {
      method: "POST",
      headers,
      body: JSON.stringify(cartData),
    })
      .then(async (res) => {
        if (res.ok) {
          return res.json();
        }
        return res.json().then((data) => {
          throw data;
        });
      })
      .then((res) => {
        this.removeItem(oldVariantId, line);
      })
      .catch((error) => {
        this.updateLiveRegions(line, error.message);
        revertVariant()
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  getCart = () => {
    return fetch("/cart.js", {
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    })
      .then((response) => response.json())
      .then((data) => {
       
        return data;
      });
  };

   removeItem(variantId, line) {
    this.enableLoading(line);
    const body = JSON.stringify({
      id: `${variantId}`,
      quantity: 0,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname == "/apps/advanced-wishlist" ? "/" : window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
           
        const parsedState = JSON.parse(state);

        const cartSummary = document.getElementById('cart_summary');
        if (parsedState.item_count && cartSummary) {
          let text = parsedState.item_count > 1 ? `${parsedState.item_count} Items` : `${parsedState.item_count} Item`;
          const locale = cartSummary.getAttribute("data-locale");
          if (locale == "ko") {
            text = `${parsedState.item_count}개 품목`;
          }
          cartSummary.innerText = text;
        }
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");
        const cartItemsSummary = document.querySelector(".cart-item-count");
        if (cartItemsSummary) {
          cartItemsSummary.innerHTML = parsedState.item_count;
        }

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);
    let body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname == "/apps/advanced-wishlist" ? "/" : window.location.pathname,
    });
    if (variantId) {
      body = JSON.stringify({
        id: variantId,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname == "/apps/advanced-wishlist" ? "/" : window.location.pathname,
      });
    }

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const cartSummary = document.getElementById('cart_summary');
        if (parsedState.item_count && cartSummary) {
          let text = parsedState.item_count > 1 ? `${parsedState.item_count} Items` : `${parsedState.item_count} Item`;
          const locale = cartSummary.getAttribute("data-locale");
          if (locale == "ko") {
            text = `${parsedState.item_count}개 품목`;
          }
          cartSummary.innerText = text;
        }
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");
        const cartItemsSummary = document.querySelector(".cart-item-count");
        if (cartItemsSummary) {
          cartItemsSummary.innerHTML = parsedState.item_count;
        }

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
            if(elementToReplace) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
            }
          
        });
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });
        setTimeout(function(){ HulkappWishlist.init(); }, 1000);
      })
      .catch((err) => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError){
      let updatedMessage = message;
      const regex = /카트에 (.+?) - (.+?(?: \/ .+?)?)를 추가할 수 없습니다\./;
      const match = message.match(regex);
      if (match) {
        const productName = match[1];
        const size = match[2];
        updatedMessage = `장바구니에 ${productName} 상품을 추가할 수 없습니다.`;
      }
      lineItemError.querySelector(".cart-item__error-text").innerHTML = updatedMessage;
    }

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {  
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden")
    );
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
